module.exports = __webpack_public_path__ + "static/media/Ciderama2020v2.1fed3064.mp4";